import React from "react";
import { formatedDate } from "./utils/formattedDate";
import WeatherTemperature from "./WeatherTemperature";

export default function WeatherInfo({ weatherData }) {
  const { day, hours, minutes } = formatedDate(weatherData.date);
  return (
    <div className="WeatherInfo mb-5">
      <h1 className="text-dark">{weatherData.city}</h1>
      <ul style={{ padding: 0 }}>
        <li>
          {day} {hours}:{minutes}
        </li>
        <li className="text-capitalize">{weatherData.desc}</li>
      </ul>
      <div className="row mt-3">
        <div className="col-6">
          <div className="d-flex flew-row">
            <img
              src={weatherData.iconURL}
              alt={weatherData.desc}
              className="float-left"
            />
            <div className="float-left">
              <WeatherTemperature
                celsius={Math.round(weatherData.temperature)}
              />
            </div>
          </div>
        </div>
        <div className="col-6">
          <ul>
            <li>Humidity: 72%</li>
            <li>Wind: {weatherData.wind} km/h</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
